import { create } from 'zustand';

const useNonProfitOnBoardDialogStore = create((set) => ({
  open: false,
  nonProfitId: null,
  setOpen: (isOpen, nonProfit) =>
    set(() => ({ open: isOpen, nonProfit: nonProfit || null })),
  join: () => {},
}));

export default useNonProfitOnBoardDialogStore;
